<div class="step-container registration-personal-details">
  <div class="d-flex flex-column justify-content-between h-100">
    <div class="mb-5" *ngIf="!loading">
      <h5>{{ 'fgbcl.registration.personal.details.title' | translate }}</h5>

      <fgbcl-errors></fgbcl-errors>
      <div class="model-meta-data-form-container" *ngIf="personalDetailsForm">
        <fgbcl-model-meta-data-form
          [formGroup]="personalDetailsForm"
          [wscPrefix]="wscKey"
          [models]="models"
          [minDate]="minDate"
          [maxDate]="maxDate"
        ></fgbcl-model-meta-data-form>
      </div>
    </div>
    <ng-container *ngIf="loading">
      <div class="w-100">
        <fgbcl-loading></fgbcl-loading>
      </div>
    </ng-container>
    <div class="button-container mt-auto">
      <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
    </div>
  </div>
</div>
